<template>
  <Dropdown v-model="showOpenningHours">
    <template #button>
      <button class="flex items-center text-sm text-body" @click="showOpenningHours = true">
        <div v-if="currentOpenningPeriod">
          Open today until {{ formatTime(currentOpenningPeriod.close.time) }}
        </div>
        <div v-else>
          <span v-if="nextOpenningPeriod && isDayToday(nextOpenningPeriod.open.day)">Opens today at</span>
          <span v-else>Closed; reopens</span>
          <span v-if="nextOpenningPeriod">
            <span v-if="isDayToday(nextOpenningPeriod.open.day)" />
            <span v-else-if="isDayTomorrow(nextOpenningPeriod.open.day)">tomorrow</span>
            <span v-else>{{ weekdays[nextOpenningPeriod.open.day - 1] }}</span>
            {{ formatTime(nextOpenningPeriod.open.time) }}
          </span>
        </div>
        <ChevronIcon class="ml-2" />
      </button>
    </template>
    <table>
      <tr v-for="(line, idx) in venue.opening_hours.opening_text" :key="idx">
        <td v-for="(part, i) in line.split(/:(.*)/s)" :key="i" class="mb-0.5 whitespace-nowrap text-sm text-body">
          {{ part }}
          <span v-if="i === 0" class="mr-2">:</span>
        </td>
      </tr>
    </table>
  </Dropdown>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localeData from 'dayjs/plugin/localeData'
import Dropdown from '~/components/shared/Dropdown'
import ChevronIcon from '~/components/icons/ChevronIcon'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localeData)

const weekdays = dayjs.weekdays()

export default {
  components: { ChevronIcon, Dropdown },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => ({
    showOpenningHours: false,
    weekdays: [...weekdays.slice(1, 7), weekdays[0]],
  }),

  computed: {
    venueTime () {
      if (! this.venue.opening_hours) { return }
      return dayjs().tz(this.venue.opening_hours.timezone)
    },

    currentDayTime () {
      if (! this.venue.opening_hours) { return }
      const time = this.venueTime.format('HHmm')
      let day = Number.parseInt(this.venueTime.format('d'))
      if (day === 0) { day = 7 } // Sunday shuld be 7

      return [day, time]
    },

    currentOpenningPeriod () {
      if (! this.venue.opening_hours) { return }
      const [day, time] = this.currentDayTime

      return this.venue.opening_hours.opening_periods.find((p) => {
        return p.open.day === day && p.open.time <= time && (time < p.close.time || p.close.time === '0000')
      })
    },

    nextOpenningPeriod () {
      if (! this.venue.opening_hours) { return }
      if (this.currentOpenningPeriod) { return null }
      const [day, time] = this.currentDayTime

      for (let i = 0; i < 7; i++) {
        let checkDay = day + i
        if (checkDay > 7) { checkDay = checkDay - 7 }
        const period = this.venue.opening_hours.opening_periods.find((p) => {
          return p.open.day === checkDay && (day !== checkDay || p.open.time > time)
        })
        if (period) { return period }
      }

      return null
    },
  },

  methods: {
    formatTime (time) {
      return dayjs(`2022-11-11 ${time}:00`, 'YYYY-MM-DD HHmm:ss').format(time.endsWith('00') ? 'ha' : 'h:mma')
    },

    isDayToday (day) {
      const [currDay] = this.currentDayTime
      return currDay === day
    },

    isDayTomorrow (day) {
      const [currDay] = this.currentDayTime
      let nextDay = day + 1
      if (nextDay > 7) { nextDay = 1 }

      return currDay === nextDay
    },
  },
}
</script>
